'use client';

import { usePathname } from 'next/navigation';
import { FC } from 'react';

import { Button } from '@/general/components/Button/Button';

type FooterSubscribeProps = {
  heading: string;
  subHeading: string;
  ctaButton: {
    label: string;
    href: string;
  };
};

export const FooterSubscribe: FC<FooterSubscribeProps> = ({ heading, subHeading, ctaButton }) => {
  const pathname = usePathname();
  const isSubscribePage = pathname === '/subscribe';

  // If the page is the subscribe page, don't render the footer subscribe
  if (isSubscribePage) {
    return null;
  }

  return (
    <section className="mx-auto mb-10 flex max-w-7xl flex-col gap-6 rounded-lg bg-bac-tie2 p-4 md:flex-row md:items-center md:justify-between md:p-6">
      <header>
        <h3 className="c-fs-h5 font-extrabold">{heading}</h3>
        <p className="c-fs-body2 text-tex-def-tie2">{subHeading}</p>
      </header>
      <div>
        <Button href={ctaButton.href}>{ctaButton.label}</Button>
      </div>
    </section>
  );
};
